import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutUs from "./sections/AboutUs";
import OurServices from "./sections/OurServices";
import HowItWorks from "./sections/HowItWorks";
import FAQ from "./sections/FAQ";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutUs />
      <OurServices />
      <HowItWorks />
      <FAQ />
      <ContactUs />
      <Footer />
    </div>;
}